export const environment = {
  production: false,
  firebase: {
    //Production
    apiKey: "AIzaSyCROSeueEdecN4OtCNaKLEIRH-hTA2q-44",
    authDomain: "bengalhandloombazar-479a3.firebaseapp.com",
    databaseURL: "https://bengalhandloombazar-479a3.firebaseio.com",
    projectId: "bengalhandloombazar-479a3",
    storageBucket: "bengalhandloombazar-479a3.appspot.com",
    messagingSenderId: "797511382434",
  },
  API_SERVER_ADDRESS_DEV: "https://api.bhbazar.com/api",
  API_SERVER_ADDRESS_PROD: "https://api.bhbazar.com/api",
};

export const address = {

  API_SERVER_ADDRESS: "https://api.bhbazar.com/api",
  SHIPPING_CREDIT_SUCCESSPAY: "https://api.bhbazar.com/api/api/successpayment",
  SHIPPING_CREDIT_FAILPAY: "https://api.bhbazar.com/api/failurePayment",
  API_MEDIA_SERVER_ADDRESS: "https://api.bhbazar.com",
  manual_version: '0.0.13',
  SHIPPING_CREDIT_SUCCESSPAY_NEW: "https://api.bhbazar.com/api/shipping_credit/success",
  SHIPPING_CREDIT_FAILPAY_NEW: "https://api.bhbazar.com/api/shipping_credit/failed",
};